export enum ExpirationStatus {
  EXPIRED,
  LONG_EXPIRED,
  ABOUT_TO_EXPIRE,
  UNKNOWN,
}
